import { render, staticRenderFns } from "./formEdition.vue?vue&type=template&id=2a9aed50&scoped=true"
import script from "./formEdition.vue?vue&type=script&lang=js"
export * from "./formEdition.vue?vue&type=script&lang=js"
import style0 from "./formEdition.vue?vue&type=style&index=0&id=2a9aed50&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9aed50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a9aed50')) {
      api.createRecord('2a9aed50', component.options)
    } else {
      api.reload('2a9aed50', component.options)
    }
    module.hot.accept("./formEdition.vue?vue&type=template&id=2a9aed50&scoped=true", function () {
      api.rerender('2a9aed50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reverse/edition/components/form/steps/formEdition.vue"
export default component.exports